import axios from 'axios';
import Vue from 'vue'

export default {

    getDocumentsByType (page, pageSize, documentType, documentNo) {
        return axios.get('/api/document/by-type', { params: {page: page, pageSize: pageSize, documentType:documentType, documentNo:documentNo} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTraiteChequeByDocumentAndCustomer (page, pageSize, documentNo) {
        return axios.get('/api/document/traite-cheque/by-document', { params: {page: page, pageSize: pageSize, documentNo:documentNo} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}